import React from 'react';

const Badge = () => <div className="badge" />;

export default Badge;
